<div id="downloadPrompt">
  <div #promptCard
       class="prompt-card"
       [style.transform]="cardTransform"
       [class.prompt-card_dragging]="isDragging"
       [class.prompt-card_hidden]="isDismissed"
       (pointerdown)="onPointerDown($event)"
       (pointermove)="onPointerMove($event)"
       (pointerup)="onPointerUp($event)"
       (pointercancel)="onPointerCancel($event)">
    <div class="icon">
      <img src="assets/icon/icon-128.webp" alt="Pyjam icon" width="48" height="48"/>
    </div>
    <div class="info">
      <p class="title">{{ 'downloadPrompt.title' | translate }}</p>
      <p class="domain">{{ appDomain }}</p>
    </div>
    <button type="button" class="action" (click)="onInstallClick()">
      {{ 'downloadPrompt.button' | translate }}
    </button>
  </div>
</div>
